import React from "react";
import { Text, Platform } from "react-native";
// One Plus Fix for Oxygen OS and its painful Slate font truncating on bold text
// https://github.com/facebook/react-native/issues/15114

const opoFontFix = () => {
  if (Platform.OS !== "android") {
    return;
  }

  const oldRender = Text.render;
  Text.render = function (...args) {
    const origin = oldRender.call(this, ...args);
    return React.cloneElement(origin, {
      style: [{ fontFamily: "Roboto" }, origin.props.style],
      maxFontSizeMultiplier: 1,
      allowFontScaling: false,
    });
  };
};

export default opoFontFix;
